/**
 * Lê config injetada em runtime (public/runtime-config.js) com fallback ao build-time (process.env).
 */
function readWindowConfig() {
  if (typeof window === 'undefined') return {};
  return window.__UFOKKO_CONFIG__ || {};
}

export function getRuntimeEnv(key) {
  const fromWindow = readWindowConfig()[key];
  if (fromWindow && String(fromWindow).trim()) {
    return String(fromWindow).trim();
  }
  const fromBuild = process.env[key];
  return fromBuild ? String(fromBuild).trim() : '';
}

export function getApiBaseUrl() {
  return getRuntimeEnv('REACT_APP_BACKEND_URL') || 'http://localhost:8001/api';
}

export function getGoogleWebClientId() {
  return getRuntimeEnv('REACT_APP_GOOGLE_WEB_CLIENT_ID');
}

export function getAppleWebClientId() {
  return getRuntimeEnv('REACT_APP_APPLE_CLIENT_ID');
}

export function getPublicSiteUrl() {
  const fromEnv = getRuntimeEnv('REACT_APP_PUBLIC_SITE_URL');
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://ufokko.com.br';
}

export function getAppleRedirectUri() {
  const fromEnv = getRuntimeEnv('REACT_APP_APPLE_REDIRECT_URI');
  if (typeof window !== 'undefined' && window.location?.origin) {
    const current = `${window.location.origin}/login`;
    if (!fromEnv) return current;
    try {
      const envHost = new URL(fromEnv).host;
      const currentHost = new URL(current).host;
      // Evita mismatch www vs apex — Return URL na Apple deve incluir ambos os hosts
      if (envHost !== currentHost) return current;
    } catch {
      return fromEnv;
    }
    return fromEnv;
  }
  return fromEnv || 'http://localhost:3000/login';
}
